/**
 * @flow
 */

import React from 'react';
import { Field } from 'redux-form';
import { Icon, Message, Form, Input } from 'semantic-ui-react';
import { Modal, Button, FormField } from '../../../../components';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import type { ModalDialog, ReduxForm, Intl } from '../../../../type';

type EditManufacturerDialogProps = { intl: Intl } & ModalDialog & ReduxForm;

const fields = {
    input: FormField(Input),
};

const intlMessages = defineMessages({
    manufacturerNamePlaceholder: {
        id: 'pages.settings.manufacturers.form.edit.manufacturerName',
        defaultMessage: 'Manufacturer name',
    },
});

const EditManufacturerDialog = ({
    trigger,
    open,
    onClose,
    submitting,
    pristine,
    error,
    handleSubmit,
    intl,
}: EditManufacturerDialogProps) => (
    <Modal size="small" trigger={trigger} open={open} onClose={onClose}>
        <Modal.Header>
            <FormattedMessage
                id="pages.settings.manufacturers.form.edit.edit"
                defaultMessage="Edit Manufacturer"
            />
        </Modal.Header>
        <Modal.Content>
            {error && (
                <Message error>
                    <Icon name="warning sign" />
                    {error}
                </Message>
            )}
            <Form onSubmit={handleSubmit}>
                <Field
                    name="name"
                    component={fields.input}
                    placeholder={intl.formatMessage(
                        intlMessages.manufacturerNamePlaceholder,
                    )}
                    simpleValue
                />
            </Form>
        </Modal.Content>
        <Modal.Actions>
            <Button
                disabled={submitting || pristine}
                loading={submitting}
                onClick={handleSubmit}
                primary
            >
                <Icon name="checkmark" />
                <FormattedMessage
                    id="pages.settings.manufacturers.form.edit.save"
                    defaultMessage="Save"
                />
            </Button>
            <Button disabled={submitting} onClick={onClose} basic>
                <Icon name="remove" />
                <FormattedMessage
                    id="pages.settings.manufacturers.form.edit.cancel"
                    defaultMessage="Cancel"
                />
            </Button>
        </Modal.Actions>
    </Modal>
);

export default injectIntl(EditManufacturerDialog);
